// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Redux Action types
 */
export enum ActionTypes {
    // App
    SAVE_APP_SETTINGS_SUCCESS = "SAVE_APP_SETTINGS_SUCCESS",
    ENSURE_SECURITY_TOKEN_SUCCESS = "ENSURE_SECURITY_TOKEN_SUCCESS",

    LOAD_PROJECTS_SUCCESS = "LOAD_PROJECTS_SUCCESS",
    LOAD_PROJECTS_SUCCESS_KEY = "LOAD_PROJECTS_SUCCESS_KEY",

    // Projects
    LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS",
    SAVE_PROJECT_SUCCESS = "SAVE_PROJECT_SUCCESS",
    ADD_ASSET_TO_PROJECT_SUCCESS = "ADD_ASSET_TO_PROJECT_SUCCESS",
    DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS",
    CLOSE_PROJECT_SUCCESS = "CLOSE_PROJECT_SUCCESS",
    LOAD_PROJECT_ASSETS_SUCCESS = "LOAD_PROJECT_ASSETS_SUCCESS",
    DELETE_PROJECT_ASSET_SUCCESS = "DELETE_PROJECT_ASSET_SUCCESS",
    UPDATE_PROJECT_TAG_SUCCESS = "UPDATE_PROJECT_TAG_SUCCESS",
    UPDATE_PROJECT_TAGS_FROM_FILES_SUCCESS = "UPDATE_PROJECT_TAGS_FROM_FILES_SUCCESS",
    UPDATE_TAG_LABEL_COUNTS_SUCCESS = "UPDATE_TAG_LABEL_COUNTS_SUCCESS",
    DELETE_PROJECT_TAG_SUCCESS = "DELETE_PROJECT_TAG_SUCCESS",
    UPLOAD_DOCUMENT_SUCCESS_FLAG = "UPLOAD_DOCUMENT_SUCCESS_FLAG",
    
    // Connections
    LOAD_CONNECTION_SUCCESS = "LOAD_CONNECTION_SUCCESS",
    SAVE_CONNECTION_SUCCESS = "SAVE_CONNECTION_SUCCESS",
    DELETE_CONNECTION_SUCCESS = "DELETE_CONNECTION_SUCCESS",

    // Assets
    SAVE_ASSET_METADATA_SUCCESS = "SAVE_ASSET_METADATA_SUCCESS",
    LOAD_ASSET_METADATA_SUCCESS = "LOAD_ASSET_METADATA_SUCCESS",
    REFRESH_ASSET_SUCCESS = "REFRESH_ASSET_SUCCESS",
    ANY_OTHER_ACTION = "ANY_OTHER_ACTION_SUCCESS",

    SHOW_ERROR = "SHOW_ERROR",
    CLEAR_ERROR = "CLEAR_ERROR",

    SET_TITLE = "SET_TITLE",

    UPDATE_PREBUILT_SETTINGS = "UPDATE_PREBUILT_SETTINGS",
    LOAD_APP_SETTINGS_SUCCESS = "LOAD_APP_SETTINGS_SUCCESS",
    APP_ON_WIDGET_MODE = "APP_ON_WIDGET_MODE",

    AD_HOC_OCR_LOAD_PROJECT = "AD_HOC_OCR_LOAD_PROJECT",
    AD_HOC_OCR_UPDATE_PROJECT_OCR = "AD_HOC_OCR_UPDATE_PROJECT_OCR",

    CLIENT_MANAGEMENT_GET_COMPANIES = "CLIENT_MANAGEMENT_GET_COMPANIES",

    GET_AUTOLABELS = "GET_AUTOLABELS", 

    GET_AUTOLABEL_METRICS = "GET_AUTOLABEL_METRICS",
    GET_AUTOLABELING_METRICS = "GET_AUTOLABELING_METRICS",
    GET_OCR_METRICS = "GET_OCR_METRICS",
    GET_AUTOLABEL_METRICS_OPTIONS = "GET_AUTOLABEL_METRICS_OPTIONS",
    GET_FORM_RECOGNIZER_MODELS = "GET_FORM_RECOGNIZER_MODELS",
    DELETE_FORM_RECOGNIZER_MODEL = "DELETE_FORM_RECOGNIZER_MODEL",
    GET_METRICS_V2 = "GET_METRICS_V2",

    AD_HOC_OCR_V2_LOAD_PROJECT = "AD_HOC_OCR_V2_LOAD_PROJECT",
    AD_HOC_OCR_GROUP_LOAD_PROJECT = "AD_HOC_OCR_GROUP_LOAD_PROJECT", 
    SET_GENERATE_MODEL_GROUP = "SET_GENERATE_MODEL_GROUP", 

    AD_HOC_OCR_V3_LOAD_PROJECT = "AD_HOC_OCR_V3_LOAD_PROJECT",
    AD_HOC_OCR_V3_SET_PROJECT_POSTED_STATUS = "AD_HOC_OCR_V3_SET_PROJECT_POSTED_STATUS",

    AD_HOC_OCR_V3_LOAD_GROUP_PROJECT = "AD_HOC_OCR_V3_LOAD_GROUP_PROJECT",
    AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT = "AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT",
    AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT_REFRESH = "AD_HOC_OCR_V3_LOAD_GROUP_PROJECT_DOCUMENT_REFRESH",
    AD_HOC_OCR_V3_TOGGLE_PROJECT_TO_POST = "AD_HOC_OCR_V3_TOGGLE_PROJECT_TO_POST",
    AD_HOC_OCR_V3_REMOVE_GROUP_PROJECT_DOCUMENT = "AD_HOC_OCR_V3_REMOVE_GROUP_PROJECT_DOCUMENT",
}
